export default function getEnv(name) {
    let envVariable = (window.configs ? window.configs[name] : '') || process.env[name]
    return envVariable //window?.configs?.[name] || process.env[name]
}


// WEBPACK FOOTER //
// ./src/utils/env.js